<template>
  <div v-if="limits">
    <tips-content />
    <personal-data />
    <feed-efficiency />
    <meat-production-cost />
    <district-ranking />
  </div>
  <div style="background-color: #fff;border-radius: 5px;padding: 20px;" v-else>
    <a-empty />
  </div>
</template>

<script>
import TipsContent from './TipsContent.vue'
import PersonalData from './PersonalData'
import FeedEfficiency from './FeedEfficiency'
import MeatProductionCost from './MeatProductionCost';
import DistrictRanking from './DistrictRanking';
export default {
  components: {
    TipsContent,PersonalData,FeedEfficiency,MeatProductionCost,DistrictRanking,
  },
  props: [],
  data() {
    return {
      limits: false
    }
  },
  watch: {},
  computed: {},
  created() {
    this.checkLimits()
  },
  mounted() {},
  methods: {
    async checkLimits(){
      let userId = window.localStorage.getItem('staffId')
      // let factoryName = window.localStorage.getItem('factoryName')
      const res = await this.$http.get("/sat-collect/auth/permissions", { params:{userId} })
      let { success, data={} } = res;
      if (success) {
        this.limits = false
        let {factoryAndSettles=[]} = data || {}
        // let factoryAndSettles = []
        // let factoryAnimalList = factoryAndSettles.find(item => item.factoryName === factoryName)?.factoryAnimalList;
        // if(factoryAnimalList?.find(item => item.animalName === '1 猪')) this.limits = true
        factoryAndSettles.forEach(el => {
          el.factoryAnimalList && el.factoryAnimalList.forEach(item => {
            if(item.animalName === '1 猪') this.limits = true
          })
        })
      }
    },
  },
}
</script>
<style lang='scss'>
.dataContent{
  background: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 20px 0;
  .dataTitle{
    padding: 0 20px 10px;
    border-bottom: 2px solid #f0f2f5;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    .dataTitleTips{
      font-size: 12px;
      font-weight: normal;
      color: #ccc;
    }
  }
}
</style>
<style lang='scss' scoped></style>